import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {Badge, Col, Row, Spinner} from "react-bootstrap";
import Input from "../../../../common/Input";
import Button from "react-bootstrap/Button";
import axios from "axios";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {getActiveSubstance} from "../constants";
import Dropdown from "../../../../primer/Dropdown";
import {setDrugInfoModal} from "../../../../../_reducers/DataPanel/Prescription/prescriptionSlice";

const DrugsModal = ({show, setShow, handleDrugCheck, newPrescriptionDrugs, treatmentProtocolSteps}) => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const [loading, setLoading] = useState(false);
    const [drugs, setDrugs] = useState([]);
    const [drugFilter, setDrugFilter] = useState("");
    const [searchBy, setSearchBy] = useState("commercialName");
    const [tpActSub, setTPActSub] = useState("");

    const [autoFilter, setAutoFilter] = useState(false);

    useEffect(() => {
        if (autoFilter) {
            setAutoFilter(false);
            fetchDrugs();
        }
    }, [autoFilter])

    useEffect(() => {
        if (tpActSub) {
            fetchDrugs();
        }
    }, [tpActSub]);

    const searchByOptions = [
        {label: "Εμπορική Ονομασία", value: "commercialName"},
        {label: "ATC", value: "atcCode"},
        {label: "Δραστική Ουσία", value: "activeSubstances.activeSubstance.activeSubstance.description"},
        {label: "Barcode", value: "barcode"}
    ]

    const fetchDrugs = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/drugs`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                filter: drugFilter,
                searchBy: searchBy,
                tpActSub: tpActSub,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setDrugs(res.data.data);
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleAutoFilter = (searchBy, value) => {
        setSearchBy(searchBy);
        setDrugFilter(value);
        setAutoFilter(true);
    }

    const getTPActiveSubstances = () => {
        let arr = [
            {value: "", label: "Κενό"}
        ];
        for (let step of treatmentProtocolSteps) {
            if (step?.activeSubstance?.description) {
                arr.push({value: step.activeSubstance.description, label: step.activeSubstance.description});
            }
        }
        return arr;
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αναζήτηση Φαρμάκων</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <div style={{display: "flex", gap: "10px"}}>
                                <div style={{display: "flex", gap: "10px", flex: "1"}} onKeyDown={(e) => {
                                    if (e.key === "Enter") fetchDrugs();
                                }}>
                                    <div style={{flex: "2"}}>
                                        <Dropdown
                                            label={"Αναζήτηση κατά"}
                                            name={"searchBy"}
                                            options={searchByOptions}
                                            key={Math.random()}
                                            defaultValue={searchByOptions.find((el) => el.value === searchBy)}
                                            onChange={(e) => setSearchBy(e.value)}
                                        />
                                    </div>
                                    <div style={{ flex: "4" }}>
                                        <Input
                                            label={"Φίλτρο"}
                                            name={"drugFilter"}
                                            className={"m-0"}
                                            placeholder={"Αναζήτηση Φαρμάκου"}
                                            value={drugFilter}
                                            onChange={(e) => setDrugFilter(e.target.value)}
                                        />
                                    </div>
                                    <Button size={"sm"} onClick={() => fetchDrugs()} style={{ flex: "2", maxHeight: "35px", marginTop: "26px" }} disabled={loading}>
                                        Αναζήτηση
                                        {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                    </Button>
                                </div>
                                {getTPActiveSubstances()?.length > 1 && (
                                    <div style={{flex: "1"}} className={"border-left pl-3"}>
                                        <div style={{width: "50%"}}>
                                            <Dropdown
                                                name={"tpActSub"}
                                                label={"Δραστικές ουσίες Θ.Π."}
                                                key={Math.random()}
                                                options={getTPActiveSubstances()}
                                                defaultValue={getTPActiveSubstances().find((el) => el.value === tpActSub)}
                                                onChange={(e) => setTPActSub(e.value)}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            {drugs.length > 0 && (
                                <React.Fragment>
                                    <table className={"simpleClassicTable mt-1"} style={{fontSize: "14px"}}>
                                        <colgroup>
                                            <col span={1} style={{width: "5%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "5%"}}></col>
                                            <col span={1} style={{width: "10%"}}></col>
                                            <col span={1} style={{width: "20%"}}></col>
                                            <col span={1} style={{width: "5%"}}></col>
                                            <col span={1} style={{width: "5%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Ενέργειες</th>
                                            <th>Barcode</th>
                                            <th>Εμπορική Ονομασία</th>
                                            <th>Μορφή</th>
                                            <th>Περιεκτηκότητα</th>
                                            <th>Συσκευασία</th>
                                            <th>Τύπος</th>
                                            <th>ATC</th>
                                            <th>Δραστική Ουσία</th>
                                            <th>Τιμή Λιανικής</th>
                                            <th>Τιμή Αποζ. Ασφ.</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {drugs.map((item, idx) => (
                                            <tr key={`drugsTableSearch-${idx}`}>
                                                <td style={{lineHeight: "20px"}}>
                                                    {newPrescriptionDrugs.some((el) => el.id === item.id) ? (
                                                        <Badge bg={"danger"} title={"Αφαίρεση"} style={{padding: "6px", paddingTop: "2px", paddingBottom: "2px", cursor: "pointer", fontSize: "20px"}}
                                                               onClick={() => handleDrugCheck(false, item)}>-</Badge>
                                                    ) : (
                                                        <Badge bg={"success"} title={"Προσθήκη"} style={{padding: "6px", paddingTop: "2px", paddingBottom: "2px", cursor: "pointer", fontSize: "20px"}}
                                                               onClick={() => handleDrugCheck(true, item)}>+</Badge>
                                                    )}
                                                    <Badge title={"Πληροφορίες"} variant={"dark"} className={"ml-2"}
                                                           style={{
                                                               padding: "6px",
                                                               paddingTop: "2px",
                                                               paddingBottom: "2px",
                                                               cursor: "pointer",
                                                               fontSize: "20px"
                                                           }}
                                                           onClick={() => dispatch(setDrugInfoModal(item))}><i className="fa-solid fa-info"></i></Badge>
                                                </td>
                                                <td>{item.barcode}</td>
                                                <td>{item.commercialName}</td>
                                                <td>{item.formCode}</td>
                                                <td>{item.contentInternal}</td>
                                                <td>{item.packageForm}</td>
                                                <td>{item.medicineType}</td>
                                                <td>
                                                    <span style={{textDecoration: "underline", color: "blue", fontWeight: "500", cursor: "pointer"}}
                                                          onClick={() => handleAutoFilter("atcCode", item.atcCode)}>
                                                        {item.atcCode}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{textDecoration: "underline", color: "blue", fontWeight: "500", cursor: "pointer"}}
                                                          onClick={() => handleAutoFilter("activeSubstances.activeSubstance.activeSubstance.description", getActiveSubstance(item))}>
                                                        {getActiveSubstance(item)}
                                                    </span>
                                                </td>
                                                <td>{item.retailPrice}</td>
                                                <td>{item.referencePrice}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default DrugsModal
